export enum EBitfInterceptors {
  BITF_API_ERRORS_INTERCEPTOR = 'BitfApiErrorsInterceptor',
  BITF_API_UI_MESSAGES_INTERCEPTOR = 'BitfApiUiMessagesInterceptor',
  BITF_LANGUAGE_INTERCEPTOR = 'BitfLanguageInterceptor',
  BITF_OAUTH_INTERCEPTOR = 'BitfOAuthInterceptor',
  BITF_API_ENVELOPE_MAPPER_INTERCEPTOR = 'BitfApiEnvelopeMapperInterceptor',
  BITF_RETRY_INTERCEPTOR = 'BitfRetryInterceptor',
  BITF_RENEW_TOKEN_INTERCEPTOR = 'BitfRenewTokenInterceptor',
}
